import { useEffect, useState } from 'react';
import { useWindowScroll, useWindowSize } from 'react-use';
import { FloatingAction, getWindow, IconChevronUp24 } from '@stitch-fix/mode-react';
import clsx from 'clsx';
import styles from './styles.module.scss';
const onScrollToTopClick = () => getWindow()?.scrollTo({
  top: 0,
  behavior: 'smooth'
});
const ScrollToTop = () => {
  const {
    height
  } = useWindowSize();
  const {
    y
  } = useWindowScroll();
  const [isShown, setIsShown] = useState(false);
  const containerClassNames = clsx(styles.scrollToTopContainer, {
    [styles.scrollToTopContainerOpen]: isShown
  });
  useEffect(() => setIsShown(y > height / 2), [y, height]);
  return <div className={containerClassNames}>
      <FloatingAction variant="secondary" icon={<IconChevronUp24 />} onClick={onScrollToTopClick} aria-label="Back to top" />
    </div>;
};
export default ScrollToTop;